import { useEffect } from 'react';
import { MainPages, ProtectionMenuNameOptions, InsightsSubMenu } from '../../../utils/enums';
import { useStores } from '@src/components/store';

export const usePageViewEvent = (
    pageName: MainPages,
    tabName?: ProtectionMenuNameOptions | InsightsSubMenu,
    requireServiceData = true
) => {
    const { uiStore, customerStore } = useStores();
    useEffect(() => {
        if (!customerStore.selectedCustomer) {
            return;
        }
        if (requireServiceData && !customerStore.selectedLocation) {
            return;
        }
        uiStore.sendPageViewEvent(pageName, tabName);
    }, [
        customerStore.selectedCustomer,
        customerStore.selectedLocation,
        pageName,
        tabName,
        requireServiceData
    ]);
};
